shadow$provide[5] = function(require,module,exports) {
"use strict";
exports.__esModule = true;
/* eslint-disable react/no-unused-prop-types */
var react_1 = require("react");
var ThreestrapContext_1 = require("./ThreestrapContext");
var ALLOWED_CONTROLS = ["orbit"];
var useOrbitControls = function (threestrap, _a) {
    var type = _a.type, enablePan = _a.enablePan, enableRotate = _a.enableRotate, enableZoom = _a.enableZoom, onStart = _a.onStart, onEnd = _a.onEnd;
    (0, react_1.useEffect)(function () {
        if (type !== "orbit")
            return;
        if (!threestrap.controls)
            return;
        var controls = threestrap.controls;
        if (enablePan !== undefined) {
            controls.enablePan = enablePan;
        }
        if (enableZoom !== undefined) {
            controls.enableZoom = enableZoom;
        }
        if (enableRotate !== undefined) {
            controls.enableRotate = enableRotate;
        }
    }, [type, enablePan, enableRotate, enableZoom, threestrap.controls]);
    (0, react_1.useEffect)(function () {
        if (type !== "orbit")
            return function () { };
        if (!threestrap.controls)
            return function () { };
        var controls = threestrap.controls;
        if (onStart) {
            controls.addEventListener("start", onStart);
        }
        return function () {
            if (onStart) {
                controls.removeEventListener("start", onStart);
            }
        };
    }, [type, onStart, threestrap.controls]);
    (0, react_1.useEffect)(function () {
        if (type !== "orbit")
            return function () { };
        if (!threestrap.controls)
            return function () { };
        var controls = threestrap.controls;
        if (onEnd) {
            controls.addEventListener("end", onEnd);
        }
        return function () {
            if (onEnd) {
                controls.removeEventListener("end", onEnd);
            }
        };
    }, [type, onEnd, threestrap.controls]);
};
var Controls = function (props) {
    if (!ALLOWED_CONTROLS.includes(props.type)) {
        throw new Error("Invalid control type ".concat(props.type));
    }
    var threestrap = (0, ThreestrapContext_1.useThreestrap)();
    useOrbitControls(threestrap, props);
    return null;
};
exports["default"] = Controls;
//# sourceMappingURL=Controls.js.map
};